import { getRailsEnv, RailsEnv } from './railsEnv';

const faviconPath = ({
  admin,
  railsEnv,
}: {
  admin?: boolean;
  railsEnv?: RailsEnv;
} = {}): string => {
  const env = railsEnv || getRailsEnv();

  // these favicons created in this Figma document
  // https://www.figma.com/file/R2a9eL6fEQMq24CY2Q8752NB/Favicons?node-id=19%3A29
  if (admin) {
    if (env === 'development') {
      return 'https://imgdrop.imgix.net/1bd03e41b990465e93d1c5b90ba36c16.png';
    } else if (env === 'staging') {
      return 'https://imgdrop.imgix.net/a8dddd737aeb4780bf9e8edfa8bdc27b.png';
    } else if (env === 'qa') {
      return 'https://imgdrop.imgix.net/28c43a220c9247f1ba3764c6aa7f67b3.png';
    }

    return 'https://imgdrop.imgix.net/6f05fac182304e3d821592580acf3a68.png';
  }

  if (env === 'development') {
    return 'https://imgdrop.imgix.net/4ec068f491b4478293d83b56911a2f65.png';
  } else if (env === 'staging') {
    return 'https://imgdrop.imgix.net/006a1ec0195a4e95bea9bd906d99130c.png';
  } else if (env === 'qa') {
    return 'https://imgdrop.imgix.net/5618f1f758be4937861351a1c96548d6.png';
  }

  return 'https://imgdrop.imgix.net/cf88fd37a91e43b0b7aafe6b076d2810.png';
};

export default faviconPath;
